/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const US_DATE_FORMAT = 'MMM dd yyyy';
export const CME_DATE_FORMAT = 'MM/dd/yy';
